import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import CallIcon from '@mui/icons-material/Call';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';

import './styles/Contact.scss'
import InputField from '../components/InputField/InputField';
import Button from '../components/Button/Button';

const Contact = () => {
  return (
    <main>
        <Breadcrumbs/>
        <section>
          <div className="contact">
            <div className="container">
              <h1>Contact Us</h1>
              <div className="contact-wrapper">
                <div className="contact-form">
                  <p>We love hearing from you, our Shop customers.</p>
                  <p>Please contact us and we will make sure to get back to you as soon as we possibly can.</p>
                  <form>
                    <div className="inputs">
                      <InputField label='Your Name' required/>
                      <InputField label='Your Email' required/>
                      <InputField label='Your Phone Number'/>
                    </div>
                    <textarea placeholder='What`s on Your Mind?'></textarea>
                    <div className="contact-button">
                      <Button variant='filled'>Submit</Button>
                    </div>
                  </form>
                </div>
                <div className="contact-info">
                  <div className="contact-info-item">
                    <div className="image">
                      <RoomOutlinedIcon/>
                    </div>
                    <div className="contact-info-item-content">
                      <h3>Address:</h3>
                      <p>1234 Street Adress City Address, 1234</p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <div className="image">
                      <CallIcon/>
                    </div>
                    <div className="contact-info-item-content">
                      <h3>Phone:</h3>
                      <p>(00)1234 5678</p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <div className="image">
                      <AccessTimeIcon/>
                    </div>
                    <div className="contact-info-item-content">
                      <h3>We are open:</h3>
                      <p>Monday - Thursday: 9:00 AM - 5:30 PM<br/>Friday 9:00 AM - 6:00 PM<br/>Saturday: 11:00 AM - 5:00 PM</p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <div className="image">
                      <EmailOutlinedIcon/>
                    </div>
                    <div className="contact-info-item-content">
                      <h3>E-mail:</h3>
                      <p><a href="mailto:shop@email.com">shop@email.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </main>
  )
}

export default Contact